import { APP_TIMEZONE } from '~/const/timezone';

/**
 * Generates a timestamp in Norwegian timezone (Europe/Oslo) formatted as ISO 8601 string.
 *
 * Note: We use 'sv-SE' (Swedish) locale instead of 'nb-NO' (Norwegian) because:
 * - sv-SE produces YYYY-MM-DD HH:mm:ss format which is closer to ISO 8601 standard
 * - This makes it easier to convert to proper ISO format by simple string replacements
 * - nb-NO would produce DD.MM.YYYY format requiring complex date component rearrangement
 *
 * @returns ISO 8601 formatted timestamp string with Norwegian timezone (e.g., "2025-09-17T12:32:22.788Z")
 */
const generateNorwegianTimestamp = (): string => {
    const now = new Date();
    return (
        now
            .toLocaleString('sv-SE', {
                timeZone: APP_TIMEZONE,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                fractionalSecondDigits: 3,
                hour12: false,
            })
            .replace(' ', 'T')
            .replace(',', '.') + 'Z'
    );
};

export default generateNorwegianTimestamp;
